function _extends() {_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);} /* eslint-disable max-lines */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable max-statements */
import React, { useEffect, useMemo, useRef, useState } from 'react';
import {

  useLoaderData,
  useLocation,
  useSearchParams,
  createSearchParams } from
'react-router-dom';
import { useForm } from 'react-hook-form';

import _ from 'lodash';

import { Translate, t } from "../../../../I18N";
import { searchParamsFromSearchParams } from "../../../../utils/routeHelpers";
import { SettingsContent } from "../../../Components/Layouts/SettingsContent";
import { InputField, DateRangePicker } from "../../../Components/Forms";
import { PaginationState, Paginator, Table } from "../../../Components/UI";
import * as activityLogAPI from "../../../api/activityLog";

import { useIsFirstRender } from "../../../CustomHooks/useIsFirstRender";

import { useAtomValue } from 'jotai';

import { settingsAtom, translationsAtom } from "../../../atoms";
import { getActivityLogColumns } from "./components/TableElements";
import { ActivityLogSidePanel } from "./components/ActivityLogSidePanel";

const ITEMS_PER_PAGE = 100;









const sortingParams = ['method', 'time', 'username', 'url'];












const getQueryParamsBySearchParams = (searchParams) => {
  const {
    username,
    search,
    from,
    to,
    sort = 'time',
    order = 'desc',
    page = 1,
    limit = ITEMS_PER_PAGE
  } = searchParams;

  let time = {};
  if (from !== undefined && to !== undefined) {
    const fromDate = new Date(from).getTime() / 1000;
    const toDate = new Date(to).getTime() / 1000;
    time = { time: { from: fromDate, to: toDate } };
  }
  const sortOptions = sortingParams.includes(sort) ?
  { prop: sort, asc: +(order === 'asc') } :
  { prop: 'time', asc: 0 };
  const params = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({},
  username !== undefined ? { username } : {}),
  search !== undefined ? { method: [search] } : {}),
  search !== undefined ? { find: search } : {}),
  search !== undefined ? { search } : {}),
  time), {}, {
    page,
    limit,
    sort: sortOptions });

  return params;
};
const activityLogLoader =
(headers) =>
async ({ request }) => {
  const urlSearchParams = new URLSearchParams(request.url.split('?')[1]);
  const searchParams = searchParamsFromSearchParams(urlSearchParams);
  const params = getQueryParamsBySearchParams(searchParams);
  const activityLogList = await activityLogAPI.get(params, headers);
  if (activityLogList.message !== undefined) {
    return {
      error: activityLogList.message,
      activityLogData: [],
      totalPages: 0,
      page: 0,
      total: 0
    };
  }
  const total = Number(params.page) * activityLogList.rows.length + activityLogList.remainingRows;
  const totalPages = Math.ceil(total / params.limit);

  return {
    activityLogData: activityLogList.rows,
    totalPages,
    page: params.page,
    total
  };
};











const ActivityLog = () => {
  const [selectedEntry, setSelectedEntry] = useState(null);
  const { dateFormat = 'yyyy-mm-dd' } = useAtomValue(settingsAtom);
  const { locale } = useAtomValue(translationsAtom);
  const [sorting, setSorting] = useState([]);
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const isFirstRender = useIsFirstRender();
  const searchedParams = searchParamsFromSearchParams(searchParams);
  const {
    sort,
    order,
    from = '',
    to = '',
    page = 1,
    limit = ITEMS_PER_PAGE,
    username,
    search
  } = searchedParams;
  const {
    register,
    watch,
    setValue,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    defaultValues: {
      username,
      search,
      from,
      to
    }
  });

  const { activityLogData, totalPages, total, error } = useLoaderData();

  const onCloseSidePanel = () => {
    setSelectedEntry(null);
  };

  const changedParams = (filterPairs) => {
    const newFilters = createSearchParams(filterPairs);
    return Array.from(newFilters).filter(([_key, value]) => value !== '');
  };

  const updateSearch = (filters) => {
    const filterPairs = _(filters).toPairs().sortBy(0).value();
    const changedPairs = changedParams(filterPairs);
    if (!_.isEqual(changedPairs, Array.from(searchParams))) {
      setSearchParams((prev) => {
        filterPairs.forEach(([key, value]) => {
          if (value !== undefined && value !== '') {
            prev.set(key, value);
          } else {
            prev.delete(key);
          }
        });
        return prev;
      });
    }
  };

  useEffect(() => {var _sorting$, _sorting$2;
    const sortingProp = sorting === null || sorting === void 0 ? void 0 : (_sorting$ = sorting[0]) === null || _sorting$ === void 0 ? void 0 : _sorting$.id;
    const sortingOrder = sorting !== null && sorting !== void 0 && (_sorting$2 = sorting[0]) !== null && _sorting$2 !== void 0 && _sorting$2.desc ? 'desc' : 'asc';
    if (isFirstRender && (!sortingProp || sortingProp === sort && sortingOrder === order)) {
      return;
    }
    updateSearch({ sort: sortingProp, order: sortingOrder });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sorting]);

  const onSubmit = async (data) => {
    updateSearch(data);
  };

  const debouncedChangeHandler = useMemo(
    () => (handler) => _.debounce(handler, 500),
    []
  );

  const de = useRef(null);

  const handleInputSubmit =
  (field) => (e) => {
    setValue(field, e.target.value);
    handleSubmit(onSubmit);
  };

  useEffect(() => {var _de$current;
    (_de$current = de.current) === null || _de$current === void 0 ? void 0 : _de$current.cancel();
    const subscription = watch(async () => {
      de.current = debouncedChangeHandler(handleSubmit(onSubmit))();
      return de.current;
    });
    return () => subscription.unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handleSubmit]);

  const columns = getActivityLogColumns(setSelectedEntry, dateFormat);

  return /*#__PURE__*/(
    _jsx("div", {
      className: "tw-content",
      style: { width: '100%', overflowY: 'auto', scrollbarGutter: 'stable' },
      "data-testid": "settings-activity-log" }, void 0, /*#__PURE__*/

    _jsx(SettingsContent, {}, void 0, /*#__PURE__*/
    _jsx(SettingsContent.Header, { title: "Activity Log" }), /*#__PURE__*/
    _jsx(SettingsContent.Body, { className: "space-y-3" }, void 0, /*#__PURE__*/
    _jsx("form", {
      id: "activity-filters-form mr-10",
      onSubmit: handleSubmit(async (data) => onSubmit(data)) }, void 0, /*#__PURE__*/

    _jsx("div", { className: "flex flex-row gap-4 justify-items-stretch items-center" }, void 0, /*#__PURE__*/
    _jsx("h2", { className: "p-4 w-40 text-base font-semibold text-left" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Activity Log")
    ), /*#__PURE__*/
    React.createElement(InputField, _extends({
      id: "username",
      label: "User",
      className: "basis-1/5",
      hideLabel: true,
      placeholder: t('System', 'User', null, false),
      hasErrors: !!errors.username },
    register('username'), {
      clearFieldAction: () => {
        setValue('username', '');
        debouncedChangeHandler(handleSubmit(onSubmit));
      },
      onChange: debouncedChangeHandler(handleInputSubmit('username')),
      onBlur: () => {} })
    ), /*#__PURE__*/
    React.createElement(InputField, _extends({
      id: "search",
      label: "search",
      hideLabel: true,
      className: "basis-2/5",
      placeholder: t('System', 'by ids, methods, keywords, etc.', null, false) },
    register('search'), {
      clearFieldAction: () => {
        setValue('search', '');
        debouncedChangeHandler(handleSubmit(onSubmit));
      },
      onChange: debouncedChangeHandler(handleInputSubmit('search')),
      hasErrors: !!errors.search,
      onBlur: () => {} })
    ), /*#__PURE__*/

    _jsx(DateRangePicker, {

      dateFormat: dateFormat,
      language: locale,
      register: register,
      placeholderStart: t('System', 'From', null, false),
      placeholderEnd: t('System', 'To', null, false),
      labelToday: t('System', 'Today', null, false),
      className: "basis-1/3",
      hasErrors: !!errors.from || !!errors.to,
      labelClear: t('System', 'Clear', null, false),
      onFromDateSelected: (e) => {
        const fromChanged = !_.isEqual(e.target.value, from || '');
        if (fromChanged) {
          setValue('from', e.target.value);
        }
        debouncedChangeHandler(handleSubmit(onSubmit));
      },
      onToDateSelected: (e) => {
        const toChanged = !_.isEqual(e.target.value, to || '');
        if (toChanged) {
          setValue('to', e.target.value);
          debouncedChangeHandler(handleSubmit(onSubmit));
        }
      },
      onClear: () => {
        reset();
        setValue('from', '');
        setValue('to', '');
      } }, "activity-log-range"
    )
    )
    ),
    error === undefined && /*#__PURE__*/
    _jsx(Table, {
      columns: columns,
      data: activityLogData,
      sorting: sorting,
      setSorting: setSorting,
      footer: /*#__PURE__*/
      _jsx("div", { className: "flex justify-between h-6" }, void 0, /*#__PURE__*/
      _jsx(PaginationState, {
        page: Number(page),
        size: limit,
        total: total,
        currentLength: activityLogData.length }
      ), /*#__PURE__*/
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx(Paginator, {
        totalPages: totalPages,
        currentPage: Number(page),
        buildUrl: (pageTo) => {
          const updatedParams = _objectSpread(_objectSpread({}, searchedParams), {}, { page: pageTo, limit });
          return `${location.pathname}?${createSearchParams(Object.entries(updatedParams))}`;
        } }
      )
      )
      ) }

    ),

    selectedEntry && /*#__PURE__*/
    _jsx(ActivityLogSidePanel, {
      selectedEntry: selectedEntry.original,
      isOpen: selectedEntry !== null,
      onClose: onCloseSidePanel }
    )

    )
    )
    ));

};

export { ActivityLog, activityLogLoader };